module.exports = __webpack_public_path__ + "static/media/header-monteur.9deabf25.jpg";